import {webClient} from "../../config/axios";

export const deleteDownloadRequest = (list) => {
    let deletePromises = []
    list.forEach((downloadId)=>{
        deletePromises.push(webClient.delete(`/download/${downloadId}`))
    })
    return deletePromises;
};